export default "__VITE_ASSET__DogUj4Vr__"